module.exports = __webpack_public_path__ + "img/keys_and_certificates.42454ee8.png";